import React, { useEffect, useRef } from 'react';
import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { Input } from '../../../../../_metronic/_partials/controls';
import * as Yup from 'yup';

export default function PrintLabelModal({ show, onHide, initValue, onClick }) {
  const qtyRef = useRef();
  useEffect(() => {
    if (show) {
      qtyRef.current.select();
    }
  }, [show]);
  const schema = Yup.object().shape({
    qty: Yup.number().moreThan(0).required('Masukkan qty minimal lebih dari 0'),
  });

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={schema}
      initialValues={{
        qty: 0,
        product_name: initValue.product_name,
        sku: initValue.sku,
        uuid: initValue.uuid,
      }}
      onSubmit={(values) => {
        onClick(values);
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <>
          <Modal
            size="md"
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">Print Label</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay overlay-block cursor-default">
              <Form>
                <input
                  className="form-control"
                  ref={qtyRef}
                  onFocus={() => qtyRef.current.select()}
                  label="Qty"
                  placeholder="Masukkan jumlah"
                  type="number"
                  value={values.qty}
                  name="qty"
                  component={Input}
                  onChange={(e) => setFieldValue('qty', parseInt(e.target.value))}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Print
              </button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Formik>
  );
}
